import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Heart, Stethoscope, Landmark, GraduationCap, Award, ExternalLink, Instagram, Globe } from 'lucide-react';
interface AllyLink {
  type: 'web' | 'instagram';
  label: string;
  href: string;
}
interface Ally {
  category: string;
  name: string;
  role: string;
  description: string;
  links?: AllyLink[];
}
const allies: Ally[] = [{
  category: 'NEURODESARROLLO',
  name: 'Developing Brains',
  role: 'Liudmila Guas & Dr. Mauricio Chinchilla',
  description: 'Organización especializada en neurología y neurodesarrollo infantil. 3 años de colaboración continua.',
  links: [{
    type: 'web',
    label: 'Sitio web',
    href: 'https://www.thedevelopingbrains.com/en'
  }, {
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/thedevelopingbrains?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
  }]
}, {
  category: 'PEDIATRÍA',
  name: 'Dr. Andrés Marcano',
  role: 'Pediatra especializado',
  description: 'Especialista en autismo y TDAH, referente en la comunidad latina de Florida',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/mipediatratea?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D'
  }]
}, {
  category: 'PSICOLOGÍA',
  name: 'Lorena Jiménez',
  role: 'Famikids',
  description: 'Psicología infantil y familiar para el acompañamiento integral del núcleo familiar',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/famikids?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D'
  }]
}, {
  category: 'EDUCACIÓN',
  name: 'Show Me Your World Foundation',
  role: 'Fundación educativa',
  description: 'Servicios educativos especializados para niños con necesidades particulares de aprendizaje'
}, {
  category: 'IMPACTO SOCIAL',
  name: 'ASPIKA',
  role: 'Plataforma global',
  description: 'Presente en más de 70 países. Plataforma de apoyo e inclusión para familias con niños neurodiversos',
  links: [{
    type: 'web',
    label: 'Sitio web',
    href: 'https://aspikaneurodiversitycenter.com/'
  }]
}];
export function PartnershipsSection() {
  const partnerTypes = [{
    icon: Building2,
    title: 'Empresas'
  }, {
    icon: Heart,
    title: 'Fundaciones'
  }, {
    icon: Stethoscope,
    title: 'Profesionales de Salud'
  }, {
    icon: Landmark,
    title: 'Entidades Gubernamentales'
  }, {
    icon: GraduationCap,
    title: 'Instituciones Educativas'
  }, {
    icon: Award,
    title: 'Marcas Comprometidas'
  }];
  return <section id="alianzas" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-178" data-mp="27a3pch9igtd6">
      <div className="max-w-6xl mx-auto" data-id="element-179" data-mp="2emt5pil2t8wy">
        <h2 style={{
        fontSize: '32px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-180" data-mp="2enuj3tpke7hu">
          Nuestros Aliados
        </h2>
        <p style={{
        fontSize: '15px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '40px'
      }} data-id="element-181" data-mp="2tjai8d504tl3">
          Trabajamos con empresas, fundaciones y profesionales comprometidos con
          la familia
        </p>
        <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '12px',
        maxWidth: '700px',
        margin: '0 auto 40px'
      }} data-id="element-182" data-mp="37aypa20e8rv7">
          {partnerTypes.map(({
          icon: Icon,
          title
        }) => <span key={title} className="mp-ally-pill" style={{
          background: '#f0fae8',
          border: '1.5px solid #c8eaa0',
          color: '#2d5a1b',
          padding: '10px 20px',
          borderRadius: '30px',
          fontSize: '14px',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px'
        }} data-id="element-183" data-mp="3laglh2g0r7el">
              <Icon size={15} color="currentColor" data-id="element-184" data-mp="3v319n7qgail" />
              {title}
            </span>)}
        </div>
        <Link to="/quiero-ser-aliado" className="mp-ally-cta" style={{
        background: '#7DC920',
        color: 'white',
        padding: '14px 32px',
        borderRadius: '10px',
        fontWeight: 700,
        fontSize: '15px',
        border: 'none',
        display: 'block',
        width: 'fit-content',
        margin: '0 auto',
        textDecoration: 'none'
      }} data-id="element-185" data-mp="3v2fddntrdxrn">
          Quiero ser Aliado →
        </Link>
        <h3 className="mp-allies-title" style={{
        fontSize: '28px',
        fontWeight: 800,
        textAlign: 'center',
        color: '#1a1a1a',
        margin: '48px 0 32px'
      }} data-id="element-186" data-mp="1rsc72hfvlgq5">
          Nuestra Red de Aliados
        </h3>
        <div className="mp-allies-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
        maxWidth: '960px',
        margin: '0 auto'
      }} data-id="element-187" data-mp="1mutsaaf6g7a8">
          {allies.map(ally => <div key={ally.name} className="mp-ally-card" style={{
          background: 'white',
          borderRadius: '14px',
          padding: '24px 20px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          border: '1px solid #f0f0f0',
          position: 'relative'
        }} data-id="element-188" data-mp="20ss2r4qdnjkg">
              {ally.links && <span aria-hidden="true" style={{
            position: 'absolute',
            top: '12px',
            right: '12px'
          }} data-id="element-189" data-mp="384ejr7h0npij">
                  {ally.links[0].type === 'instagram' ? <Instagram size={12} color="#7DC920" data-id="element-190" data-mp="2u5572hs0rdjb" /> : <ExternalLink size={12} color="#7DC920" data-id="element-191" data-mp="2p73k3lrh2u2k" />}
                </span>}
              <span style={{
            background: '#e8f5e0',
            color: '#2d5a1b',
            fontSize: '10px',
            fontWeight: 700,
            letterSpacing: '2px',
            padding: '3px 10px',
            borderRadius: '20px',
            display: 'inline-block',
            marginBottom: '12px'
          }} data-id="element-192" data-mp="2keaiv7v7q3v8">
                {ally.category}
              </span>
              <p style={{
            fontSize: '16px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '4px'
          }} data-id="element-193" data-mp="gy6wscz3g3w5">
                {ally.name}
              </p>
              <p style={{
            fontSize: '13px',
            color: '#7DC920',
            fontWeight: 600,
            marginBottom: '8px'
          }} data-id="element-194" data-mp="uyq2hdg36xv5">
                {ally.role}
              </p>
              <p style={{
            fontSize: '13px',
            color: '#666',
            lineHeight: 1.5
          }} data-id="element-195" data-mp="78vqsz7i7fch">
                {ally.description}
              </p>
              {ally.links && <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            marginTop: '12px',
            paddingTop: '12px',
            borderTop: '1px solid #f0f0f0'
          }} data-id="element-196" data-mp="3ap2rcwumgwh1">
                  {ally.links.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#7DC920',
              fontWeight: 600,
              textDecoration: 'none'
            }} data-id="element-197" data-mp="2i344q3h198qu">
                      {link.type === 'instagram' ? <Instagram size={12} data-id="element-198" data-mp="3ar9ux5quvpy2" /> : <Globe size={12} data-id="element-199" data-mp="35sopmrwqyg2r" />}
                      {link.label}
                    </a>)}
                </div>}
            </div>)}
        </div>
        <p style={{
        fontSize: '12px',
        color: '#999',
        textAlign: 'center',
        marginTop: '24px',
        fontStyle: 'italic'
      }} data-id="element-200" data-mp="3uc0b5lv29qcr">
          * Todos los aliados han dado autorización para aparecer en este sitio
        </p>

        <div className="mp-pineyro-card" style={{
        background: '#f0fae8',
        border: '1.5px solid #7DC920',
        borderRadius: '14px',
        padding: '24px 32px',
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        maxWidth: '960px',
        margin: '20px auto 0'
      }} data-id="element-201" data-mp="36lcvgeewlwfn">
          <div className="flex items-center justify-center" style={{
          width: '56px',
          height: '56px',
          background: '#2d5a1b',
          borderRadius: '50%',
          flexShrink: 0
        }} data-id="element-202" data-mp="2nolh8je7y7ig">
            <Award size={24} color="white" data-id="element-203" data-mp="22ita43n97uv7" />
          </div>
          <div data-id="element-204" data-mp="1ohz41rnoi5zp">
            <p style={{
            fontSize: '18px',
            fontWeight: 700,
            color: '#1a1a1a'
          }} data-id="element-205" data-mp="1oiij90ly2ga1">
              Concejal Rafael Pineyro
            </p>
            <p style={{
            color: '#7DC920',
            fontWeight: 600,
            fontSize: '14px',
            margin: '4px 0'
          }} data-id="element-206" data-mp="2h7xvftpcif7j">
              Ciudad de Doral — Impacto Social e Institucional
            </p>
            <p style={{
            fontSize: '14px',
            color: '#444'
          }} data-id="element-207" data-mp="2cf4rv95m5cx1">
              Respaldo institucional de la Ciudad de Doral para los programas y
              eventos de la fundación
            </p>
          </div>
        </div>

      </div>
    </section>;
}